import { Box, Typography } from "@mui/material";
import IntegrationImage from "../../../../stack/integrations/components/IntegrationImage";

const TOTAL_ROW_ID = "total_id";

const getDiffText = (diff) => {
  return (
    <Typography variant="caption">
      {diff > 0
        ? `(↑${diff})`
        : diff < 0
        ? `(↓${Math.abs(diff)})`
        : diff === 0
        ? "( - )"
        : ""}
    </Typography>
  );
};

const getCellContent = (value, diff) => {
  if (!value) return "-";

  return (
    <Box display="flex" flexDirection="row" alignItems="center" gap={0.5}>
      <Typography variant="body2">{value} </Typography>
      {getDiffText(diff)}
    </Box>
  );
};

export const columnGroupingModel = [
  {
    groupId: "medium",
    headerName: "Medium",
    headerAlign: "center",
    children: [
      { field: "vulnerabilities_medium" },
      { field: "associations_medium" },
    ],
  },
  {
    groupId: "high",
    headerName: "High",
    headerAlign: "center",
    children: [
      { field: "vulnerabilities_high" },
      { field: "associations_high" },
    ],
  },
  {
    groupId: "critical",
    headerName: "Critical",
    headerAlign: "center",
    children: [
      { field: "vulnerabilities_critical" },
      { field: "associations_critical" },
    ],
  },
  {
    groupId: "total",
    headerName: "Total",
    headerAlign: "center",
    children: [
      { field: "vulnerabilities_total" },
      { field: "associations_total" },
    ],
  },
];

export const getColumns = () => {
  return [
    {
      field: "source",
      headerName: "Source",
      headerAlign: "center",
      align: "center",
      minWidth: 100,
      disableReorder: true,
      renderCell: (params) => (
        <IntegrationImage
          name={params.row.source === TOTAL_ROW_ID ? "" : params.value}
          width="22px"
          newLogo={true}
        />
      ),
    },
    {
      field: "vulnerabilities_medium",
      headerName: "Vulnerabilities",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: (params) =>
        getCellContent(params.value, params.row.vulnerabilitiesMediumDiff),
    },
    {
      field: "associations_medium",
      headerName: "Findings",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      renderCell: (params) =>
        getCellContent(params.value, params.row.associationsMediumDiff),
    },
    {
      field: "vulnerabilities_high",
      headerName: "Vulnerabilities",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: (params) =>
        getCellContent(params.value, params.row.vulnerabilitiesHighDiff),
    },
    {
      field: "associations_high",
      headerName: "Findings",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      renderCell: (params) =>
        getCellContent(params.value, params.row.associationsHighDiff),
    },
    {
      field: "vulnerabilities_critical",
      headerName: "Vulnerabilities",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: (params) =>
        getCellContent(params.value, params.row.vulnerabilitiesCriticalDiff),
    },
    {
      field: "associations_critical",
      headerName: "Findings",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      renderCell: (params) =>
        getCellContent(params.value, params.row.associationsCriticalDiff),
    },
    {
      field: "vulnerabilities_total",
      headerName: "Vulnerabilities",
      headerAlign: "center",
      align: "center",
      minWidth: 150,
      renderCell: (params) =>
        getCellContent(params.value, params.row.vulnerabilitiesTotalDiff),
    },
    {
      field: "associations_total",
      headerName: "Findings",
      headerAlign: "center",
      align: "center",
      minWidth: 130,
      renderCell: (params) =>
        getCellContent(params.value, params.row.associationsTotalDiff),
    },
  ];
};
